import React from 'react';
import Icon from '../../../../generic-components/Icon';
import { ILogo } from './LogoList';

interface IProps {
  item: ILogo;
  handleOnClick: () => void;
  isSelected: boolean;
}

const Logo = ({ item, handleOnClick, isSelected }: IProps) => (
  <div
    role='button'
    tabIndex={0}
    onKeyDown={() => {}}
    onClick={handleOnClick}
    className={`w-[98px] h-[78px] flex items-center justify-center rounded-[4px] cursor-pointer ${isSelected ? 'bg-action03 bg-opacity-5 border-[1.5px] border-action03' : 'hover:bg-bw01 hover:border hover:border-bw03'}`}
  >
    <Icon
      className='w-[39px] h-[41px]'
      iconId={`icon${item.id}`}
      src={`https://assets.lili.co/unified/invoice-logos/${item.name}.svg`}
      isSelected={isSelected}
    />
  </div>
);

export default Logo;
